import React from 'react';
import {Container} from 'flux/utils';


import AppUtil from 'AppUtil';
import ProductStore from 'stores/ProductStore';
import SessionStore from 'stores/SessionStore';

import HttpService from 'service/HttpService';

import ProductDetail from 'views/product/ProductDetail';
import ProductSettings from 'views/product/ProductSettings';

import {A} from 'views/AppElements';

import HeaderBanner from 'views/HeaderBanner';
import {DCUtil} from 'pages/campaigns/BuyOneDonateOne';

import SuggestedProducts from 'views/product/SuggestedProducts';

class ProductDetailContainer extends React.Component {

	static getStores() {
		return [ProductStore];
	}

	static calculateState(prevState, props) {
		const productId = props.productId;
		
		let product = ProductStore.getProduct(productId);
		product = product && product.creator? product: null;


		const creatorProducts = product? ProductStore.getCreatorProducts(product.creator): null;
		let recentProducts = ProductStore.getRecentProducts();

		if(product && product.creator && recentProducts) {
			recentProducts = recentProducts.filter(p => p.creator.username !== product.creator.username);
		}

		const newState = {
				product: product,
				productStat: ProductStore.getProductStat(productId),

				creatorProducts: creatorProducts,
				suggestedProducts: recentProducts
			};
		return newState;
	}

	componentDidMount() {
		const product = this.state.product;

		if(product === null)
			HttpService.getProduct(this.props.productId);
		else
			this.onProductAvailable(product);

		AppUtil.scrollToTop();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const product = this.state.product;

		const productChanged = prevProps.productId !== this.props.productId;
		if(product === null) {
			//check if new product link is clicked or not
			if(productChanged === true)
				HttpService.getProduct(this.props.productId);
		} else {
			this.onProductAvailable(product);
		}

		if(productChanged === true)
			AppUtil.scrollToTop();
	}

	/**this fills up product stat and suggested products**/
	onProductAvailable(product) {
		const currentUser = SessionStore.getCurrentSession()? SessionStore.getCurrentSession().user: null;
		const isAuthorized = AppUtil.isAuthorizedForProduct(currentUser, product);

		if(isAuthorized) {
			const productId = product.id;
			if(!ProductStore.getProductStat(productId))
				HttpService.getProductStat(productId);
		}

		if(!ProductStore.getCreatorProducts(product.creator)) {
			HttpService.getCreatorProducts(product.creator);
		}

		if(this.state.creatorProducts && !this.state.suggestedProducts)
			HttpService.getRecentProducts();	

	}

	render() {
		const editMode = this.props.editMode;

		const product = this.state.product;

		let creatorTitle = null;

		if(product)
			creatorTitle = <A href={AppUtil.getDesignerURL(product.creator)}>More From {AppUtil.getCreaterName(product.creator)}</A>;

		return <div className="mainContainer">
				{!editMode &&
					<ProductDetail product={product}
								productStat={this.state.productStat} selectedImage={this.props.selectedImage} />
					
				}

				{editMode &&
					<ProductSettings product={product} />
				}

				{DCUtil.isCampaignActive() && 
					<div style={{paddingTop: "30px", marginTop: "30px", borderTop: "1px solid gray"}}>
						<HeaderBanner bannerImages={[DCUtil.getDashainCampaignBanner().sort(() => .5 - Math.random())[0]]} />
					</div>
				}

				{
					product && 

					<SuggestedProducts products={this.state.creatorProducts} filterProduct={product} 
										title={creatorTitle} autoplay={false} navigator="arrows" />
				}
				
				{
					this.state.suggestedProducts && 
					<SuggestedProducts products={this.state.suggestedProducts} filterProduct={product} 
								autoplay={true} navigator="arrows" />
				}
				
			</div>
	}
}

export default Container.create(ProductDetailContainer, {withProps: true});



// WEBPACK FOOTER //
// ./src/containers/ProductDetailContainer.js